import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResNewCategorys {
  success: boolean;
  message: string;
  result: Category[];
}

interface Category {
  CATEGORT_ID: string;
  CATEGORY_NAME: string;
}

interface ResAllNews {
  message: string;
  result: News[];
  success: boolean;
}

interface News {
  ALWAYS_OPEN: string;
  ADMIN_CREATEID: string;
  NEWS_CATEGORY: string
  NEWS_DATE: Date;
  NEWS_DETAIL: string;
  NEWS_END: Date;
  NEWS_ID: number;
  NEWS_PIC: string;
  NEWS_READED: number;
  NEWS_START: Date;
  NEWS_STATUS: number;
  NEWS_TITAL: string;
}

interface ResEditNews {
  message: string;
  result: {
    createtime: Date;
  };
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NewsUpdateService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllNews() {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<ResAllNews>(environment.URL + '/manage_admin/getAllNews', { headers: headers });
  }

  getCategoryNews() {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<ResNewCategorys>(environment.URL + '/manage_admin/getCategoryNews', { headers: headers });
  }

  createNews(n) {
    let formData = new FormData();
    const headers = new HttpHeaders({ Authorization: this.token })

    if (n.newsForm.newsAlwaysOpen !== 'true') {
      formData.append('NEWS_START', n.newsForm.newsDate[0]);
      formData.append('NEWS_END', n.newsForm.newsDate[1]);
    } else {
      formData.append('NEWS_START', '');
      formData.append('NEWS_END', '');
    }

    formData.append('ALWAYS_OPEN', n.newsForm.newsAlwaysOpen);
    formData.append('NEWS_TITAL', n.newsForm.newsTital);
    formData.append('NEWS_DETAIL', n.newsForm.newsContent);
    formData.append('NEWS_CATEGORY', n.newsForm.newsCategory);
    formData.append('NEWS_PIC', n.newsForm.newsCover);

    if (n.newsForm.centerId) {
      if (n.newsForm.centerId.length > 0) {
        for (let i = 0; i < n.newsForm.centerId.length; i++) {
          const el = n.newsForm.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResNewCategorys>(environment.URL + '/manage_admin/createNews', formData, { headers: headers });
  }

  dulplicateNews(n) {
    let formData = new FormData();
    const headers = new HttpHeaders({ Authorization: this.token })

    if (n.newsForm.newsAlwaysOpen !== 'true') {
      formData.append('NEWS_START', n.newsForm.newsDate[0]);
      formData.append('NEWS_END', n.newsForm.newsDate[1]);
    } else {
      formData.append('NEWS_START', '');
      formData.append('NEWS_END', '');
    }

    formData.append('ALWAYS_OPEN', n.newsForm.newsAlwaysOpen);
    formData.append('NEWS_TITAL', n.newsForm.newsTital);
    formData.append('NEWS_DETAIL', n.newsForm.newsContent);
    formData.append('NEWS_CATEGORY', n.newsForm.newsCategory);
    formData.append('NEWS_ID', n.newsId);

    if (typeof (n.newsForm.newsCover) === 'object') {
      formData.append('NEWS_PIC', n.newsForm.newsCover);
    }

    if (n.newsForm.centerId) {
      if (n.newsForm.centerId.length > 0) {
        for (let i = 0; i < n.newsForm.centerId.length; i++) {
          const el = n.newsForm.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResNewCategorys>(environment.URL + '/manage_admin/dupplicateNewsById', formData, { headers: headers });
  }

  updateNewsById(n) {
    console.log(n.newsForm);
    let formData = new FormData();
    const headers = new HttpHeaders({ Authorization: this.token })

    if (n.newsForm.newsAlwaysOpen !== 'true') {
      formData.append('NEWS_START', n.newsForm.newsDate[0]);
      formData.append('NEWS_END', n.newsForm.newsDate[1]);
    } else {
      formData.append('NEWS_START', '');
      formData.append('NEWS_END', '');
    }

    formData.append('ALWAYS_OPEN', n.newsForm.newsAlwaysOpen);
    formData.append('NEWS_TITAL', n.newsForm.newsTital);
    formData.append('NEWS_DETAIL', n.newsForm.newsContent);
    formData.append('NEWS_CATEGORY', n.newsForm.newsCategory);
    formData.append('NEWS_ID', n.newsId);

    if (typeof (n.newsForm.newsCover) === 'object') {
      formData.append('NEWS_PIC', n.newsForm.newsCover);
    }

    if (n.newsForm.centerId) {
      if (n.newsForm.centerId.length > 0) {
        for (let i = 0; i < n.newsForm.centerId.length; i++) {
          const el = n.newsForm.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<ResEditNews>(environment.URL + '/manage_admin/editNewsById', formData, { headers: headers });
  }

  updateStatusById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResEditNews>(environment.URL + '/manage_admin/updateStatusNews', body, { headers: headers });
  }

  deleteNews(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResEditNews>(environment.URL + '/manage_admin/deleteNewsById', body, { headers: headers });
  }
}
